var XMLElement = require('./XMLElement');

/**
 * The class XMLAttribute is a wrapper for representing XML-like attributes attributes.
 * It is mainly used for defining namespaces and namespace-related attributes.
 *
 * @param {object} oConfig - Object representation of the XMLNode containing at least the tag of the element.
 * @param {string} oConfig.name - String representation of the XML tag.
 * @param {string} [oConfig.prefix] - Prefix of the {@link XMLAttribute} that will be used for XML namespace purposes.
 * @param {string} [oConfig.suffix] - Suffix of the {@link XMLAttribute} that will be used for XML namespace purposes.
 * @param {string} [oConfig.value] - Textual value of the {@link XMLAttribute}.
 * @class
 * @module xml/XMLAttribute
 */
function XMLAttribute(oConfig) {
	XMLElement.call(this, oConfig);

	this.name = oConfig.name ? oConfig.name : '';
	this.prefix = oConfig.prefix ? oConfig.prefix : '';
	this.suffix = oConfig.suffix ? oConfig.suffix : '';
}

XMLAttribute.prototype = Object.create(XMLElement.prototype);
XMLAttribute.prototype.constructor = XMLAttribute;

/**
 * Performes a String serialization of the XMLAttribute. The representation is formatted as follows:
 * <prefix>:<name>:<suffix>="<value>"
 *
 * i.E. ' xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"'
 * for { name: 'xmlns', suffix: 'xsi', value: 'http://www.w3.org/2001/XMLSchema-instance' }
 *
 * Note that the serialized String always comes with a leading whitespace to allow easy concatenation.
 *
 * @function serialize
 * @returns {string} - String representation of the XMLAttribute
 */
XMLAttribute.prototype.serialize = function(){
	return ' ' + (this.prefix ? this.prefix + ':' : '') + this.name
		+ (this.suffix ? ':' + this.suffix : '') + '="' + this.xmlEncode(this.value) + '"';
};

module.exports = XMLAttribute;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/xml/XMLAttribute.js
// module id = 20
// module chunks = 0